import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { client } from "./api-client";

export const useGetAllRoutes = (data) =>
  useQuery({
    queryKey: [
      "GetAllRoutes",
      data?.pageNumber,
      data?.pageRowCount,
      data?.searchCriteria,
      data?.operationDate,
      data?.cashCenterId,
    ],
    queryFn: ({ signal }) => client(`resources/routes`, { data, signal }),
  });

export const useAddNewRoute = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data) =>
      client(`resources/routes/add`, {
        data,
        successMessage: "Route added successfully!",
      }),
    ...{
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ["GetAllRoutes"] });
      },
    },
  });
};

export const useGetCashCenters = () =>
  useQuery({
    queryKey: ["GetCashCenters"],
    queryFn: () => client(`lookups/cash/centers`),
  });

export const useGetOffices = () =>
  useMutation({
    mutationFn: (cashCenterId) =>
      client(`lookups/cash/center/offices/${cashCenterId}`),
  });

export const useGetRegions = (state) =>
  useQuery({
    queryKey: ["GetRegions", state],
    queryFn: () => client(`lookups/regions/${state}`),
  });

export const useEditRoute = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data) =>
      client(`resources/routes/edit`, {
        data,
        successMessage: "Route updated successfully!",
      }),
    ...{
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ["GetAllRoutes"] });
      },
    },
  });
};

export const useGetRouteDetails = (id) =>
  useQuery({
    queryKey: ["GetRouteById"],
    queryFn: () => client(`resources/routes/${id}`),
  });
